// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Button from '@/components/button';
import Search from '@/components/search';
import { colors } from '@/theme';

import CellStatus from '@/components/cells/status';
import CellDate from '@/components/cells/date';
import CellBold from '@/components/cells/bold';
import CellBool from '@/components/cells/bool';
import CellEmployee from '@/components/cells/employee';
import CellDescription from '@/components/cells/description';

import KendoTable from '@/components/kendo/kendo-table';
import KendoCellStatus from '@/components/kendo/cells/kendo-cell-status';
import KendoCellEmployee from '@/components/kendo/cells/kendo-cell-employee';
import KendoCellDate from '@/components/kendo/cells/kendo-cell-date';
import KendoCellBool from '@/components/kendo/cells/kendo-cell-bool';

import KendoPager from '@/components/kendo/kendo-pager';
import Router from 'next/router';
import Fetch from '@/utils/Fetch';
import SettingsMenu from '@/components/settings/menu';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import CellWide from '@/components/cells/wide';
import { createFileRoute } from '@tanstack/react-router'



const storeColumns = [{
  Label: 'Name',
  ColumnName: 'Name',
  CellType: 'none',
}, {
  Label: 'Code',
  ColumnName: 'Code',
  CellType: 'none',
}, {
  Label: 'Telephone',
  ColumnName: 'TelephoneNumber',
  CellType: 'none',
}, {
  Label: 'Email',
  ColumnName: 'EmailAddress',
  CellType: 'none',
}, {
  Label: 'Default',
  ColumnName: 'IsDefault',
  CellType: 'icon',
}, {
  Label: 'Created',
  ColumnName: 'CreatedDate',
  CellType: 'date',
}, {
  Label: 'Created By',
  ColumnName: 'CreatedBy',
  CellType: 'none',
}, {
  Label: 'Modified',
  ColumnName: 'ModifiedDate',
  CellType: 'date',
}, {
  Label: 'Modified By',
  ColumnName: 'ModifiedBy',
  CellType: 'none',
}];

const storeAncillaryFilters = {
  IncludeClosed: [{
    type: Enums.ControlType.Switch,
    label: 'Include disabled stores',
  }],
};

function StoreList() {

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const [columnState, setColumnState] = useState(storeColumns);

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  const columns = React.useMemo(
    () => columnState.map(function (column: any) {
      let columnObject = {
        Header: column.Label,
        accessor: column.ColumnName,
        // for table resize columns
        ColumnName: column.ColumnName,
        UserWidth: column.UserWidth
        // for table resize columns
      };

      if (column.CellType != "none") {
        switch (column.CellType) {
          case 'employee':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellEmployee value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellEmployee {...props} employeesField="Employees" />;
            break;
          case 'date':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellDate value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellDate {...props} />;
            break;
          case 'status':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellStatus value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellStatus {...props} />;
            break;
          case 'bold':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBold value={value} />;
            break;
          case 'icon':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBool value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellBool {...props} />;
            break;
          case 'Description':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellDescription value={value} />;
            break;
          default:
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBold value={value} />;
        }
      }

      if (column.ColumnName == 'LocationDisplay') {
        columnObject['Cell'] = ({ cell: { value } }: any) => <CellWide value={value} />;
      }

      if (column.ColumnName == 'InventoryDescription') {
        columnObject['Cell'] = ({ cell: { value } }: any) => <CellWide value={value} />;
      }

      if (column.ColumnName == 'CustomerContactFullName') {
        columnObject['Cell'] = ({ cell: { value } }: any) => <CellWide value={value} />;
      }

      return columnObject;
    }),
    [columnState]
  );

  const [storeResults, setStoreResults] = useState<any[]>([]);
  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [searching, setSearching] = useState(false);
  const [searchVal, setSearchVal] = useState('');
  const [ancillaryFilters, setAncillaryFilters] = useState({ IncludeClosed: false });
  const [totalResults, setTotalResults] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
 
  const pageSizeChanged = (size: any) => {
    setPageSize(size);
  };

  const pageChanged = (page: any) => {
    setCurrentPage(page);
  };

  const handleAncillaryFilterChange = (result: any) => {
    if (result.reset) {
      setAncillaryFilters({ IncludeClosed: false });
    } else {
      setAncillaryFilters({ IncludeClosed: result.checked });
    }
  };

  useEffect(() => {
    if (currentPage == 1) {
      searchStores();
    } else {
      setCurrentPage(1);
    }
  }, [sortField, sortDirection, pageSize, ancillaryFilters]);

  useEffect(() => {
    searchStores();
  }, [currentPage]);

  useEffect(() => {
    getAccessStatus();
  }, []);
  
  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);

  function setSort(field: any) {
    setSortDirection(Helper.getSortDirection(field, sortField, sortDirection));
    setSortField(field);
  }

  async function searchStores() {
    setSearching(true);

    const stores = await Fetch.post({
      url: `/Store/GetStores`,
      params: {
        pageSize: pageSize,
        pageIndex: (currentPage - 1),
        searchPhrase: searchVal,
        sortExpression: sortField,
        sortDirection: sortDirection,
        IncludeClosed: ancillaryFilters["IncludeClosed"],
      }
    });
    setStoreResults(stores.Results);
    setTotalResults(stores.TotalResults);

    setSearching(false);
  }

  function rowClick(row: any) {
    Helper.nextRouter(Router.push,`/settings/store/[id]`,`/settings/store/${row.original.ID}`);
  }

  const createStore = () => {
    Helper.nextRouter(Router.push,"/settings/store/create", "/settings/store/create");
  }

  return (
    <div className="list-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '', suppressLink: true },
              { text: 'Stores', link: '/settings/store/list' },
            ]}
          />
        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">

          <div className="row end">
            <div className="search-container">
              <Search
                placeholder="Search Name, Code or Email"
                resultsNum={storeResults.length}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                searchFunc={searchStores}
                ancillaryFilters={storeAncillaryFilters}
                setAncillaryFilters={handleAncillaryFilterChange}
              />
            </div>

            <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
              text="Create" icon="plus-circle" extraClasses="fit-content no-margin" onClick={createStore} />
          </div>

          <div className={"no-items" + (storeResults.length == 0 ? " no-items-visible" : "")}>
            <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
              <div className="loader"></div>
            </div>
            <img src="/job-folder.svg" alt="Store Folder" />
            <h3>No stores found</h3>
            <p>If you can't find a store, try another search or create a new one.</p>
            <a href="/settings/store/create"><img src="/icons/plus-circle-blue.svg" alt="plus" /> Add new store</a>
            <img className="wave" src="/wave.svg" alt="wave" />
          </div>

          <div className="margin-top">
            {storeResults.length != 0 ? <KendoTable
              searching={searching}
              actions={[
                {text: "Edit", icon: "edit", function: (row: any) => Helper.nextRouter(Router.push,`/settings/store/${row.ID}`)},
              ]}
              columns={columns}
              data={storeResults}
              rowClick={rowClick}
              setSort={setSort}
              sortField={sortField}
              sortDirection={sortDirection}
              type="Store"
              heightOffset={300}
              highlightColumnName="Name"
            /> : ""}
          </div>

          <KendoPager pageSizeChanged={pageSizeChanged} pageChanged={pageChanged} totalResults={totalResults} searchValue={searchVal} parentPageNumber={currentPage} />

        </div>
      </div>

      <style jsx>{`
        .inverted {
          background-color: ${colors.blueDark};
        }
        .column {
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        a {
          text-decoration: none;
        }
        .margin-top {
          margin-top: 0.5rem;
        }
      `}</style>
    </div>
  );
}

export default StoreList;

export const Route = createFileRoute('/_authenticated/settings/store/list')({ component: StoreList })
